import React, { useEffect, useState } from "react";
import { Button, Row, Col, Spin } from "antd";
import styles from "../styles/Migration.module.css";
import dark from "../styles/MigrationDark.module.css";
import { useWeb3React } from "@web3-react/core";
import ERC0721 from "../abis/ERC721.json";
import ERC1155 from "../abis/ERC1155.json";
import TOKENMAP from "../data/token_map.json";
import Web3 from "web3";
import axios from "axios";
import NftCard from "../Components/Migration/NftCard";
import Navbar from "../Components/Global/Navbar";
import ConnectWallet from "../Components/Global/ConnectWallet";
import Loader from "../util/Loader";
import { ethers } from "ethers";
import ConfirmMigrate from "../util/Modals/ConfirmMigrateSelected";
import ConfrimMigrateAll from "../util/Modals/ConfirmMigrateAll";

const Migration = ({ theme, setTheme }) => {
  const { active, account, deactivate } = useWeb3React();
  const [nfts, setNfts] = useState([]);
  const [dosNfts, setDosNfts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedNft, setSelectedNft] = useState([]);
  const [openSelected, setOpenSelected] = useState(false);
  const [openAll, setOpenAll] = useState(false);
  function intersectTokens(response) {
    const tokenIds = Object.keys(TOKENMAP);
    const ownedIds = response["ownedNfts"].map((x) => x["tokenId"]);
    const return_value = tokenIds.filter((x) => ownedIds.includes(x));
    return return_value;
  }
  const dos_punks_1155 = "0x495f947276749Ce646f68AC8c248420045cb7b5e";
  const dos_punks_0721 = "0x0Aa480688025A018EBA2FE8474D5Ca545de8e9a0";

  async function handleMigrationSelected(event) {
    console.log("migrate selected");
    console.log({ selectedNft });
    const idsToMigrate = selectedNft.map((x) => x.tokenId);
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const contract_1155 = new ethers.Contract(
      dos_punks_1155,
      ERC1155,
      provider
    );
    const contract_0721 = new ethers.Contract(
      dos_punks_0721,
      ERC0721,
      provider
    );
    const res = await contract_1155.isApprovedForAll(account, dos_punks_0721);

    var signer = provider.getSigner();
    var contract_1155_with_signer = contract_1155.connect(signer);
    var contract_0721_with_signer = contract_0721.connect(signer);

    if (!res) {
      console.log("got here");
      const transaction = await contract_1155_with_signer.setApprovalForAll(
        dos_punks_0721,
        true
      );
    }
    contract_0721_with_signer.migrateBatch(idsToMigrate);
  }
  async function getTokens(wallet_address) {
    console.log("[ getTokens ] wallet address:", wallet_address);
    const options = { method: "GET", headers: { accept: "application/json" } };

    //mainnet
    const prefix =
      "https://eth-mainnet.g.alchemy.com/nft/v3/nLeTw4kEJZvFG5VNZY1TmgVXeI6cTdBM/getNFTsForOwner?owner=";
    const suffix =
     "&contractAddresses[]=0x495f947276749ce646f68ac8c248420045cb7b5e&withMetadata=true&pageSize=100";

    // goerli
     /*const prefix =
       "https://eth-goerli.g.alchemy.com/nft/v3/nLeTw4kEJZvFG5VNZY1TmgVXeI6cTdBM/getNFTsForOwner?owner=";
     const suffix =
       '&contractAddresses[]=0xD1619BCAbc52DADd3068d7cDBD555a7F2d0C575b&withMetadata=true&pageSize=100';*/

    const string = prefix.concat(account, suffix);
    const res = await axios.get(string);
    const data = await res.data;
    console.log({ data });
    const tokenIds = Object.keys(TOKENMAP);
    console.log({ tokenIds });
    const myNfts = data?.ownedNfts;
    console.log({ myNfts });
    // const ownedIds = data?.ownedNfts.map((x) => x["tokenId"]);
    const return_value = myNfts.filter((val) => tokenIds.includes(val.tokenId));
    console.log({ return_value });
    return return_value;
  }
  async function getDosTokens() {
    const options = { method: "GET", headers: { accept: "application/json" } };
     //mainnet
    const prefix =
      "https://eth-mainnet.g.alchemy.com/nft/v3/nLeTw4kEJZvFG5VNZY1TmgVXeI6cTdBM/getNFTsForOwner?owner=";
    const suffix =
      "&contractAddresses[]=0x0Aa480688025A018EBA2FE8474D5Ca545de8e9a0&withMetadata=true&pageSize=100";

    /* //goerli
     const prefix =
       "https://eth-goerli.g.alchemy.com/nft/v3/nLeTw4kEJZvFG5VNZY1TmgVXeI6cTdBM/getNFTsForOwner?owner=";
     const suffix =
       "&contractAddresses[]=0xD55F4b897b6f277656F5ba3f812AA43bf5F75B50&withMetadata=true&pageSize=100";*/

    const string = prefix.concat(account, suffix);
    const res = await axios.get(string);
    const data = await res.data;
    console.log({ data });
    const tokenIds = Object.keys(TOKENMAP);
    console.log({ tokenIds });
    const myNfts = data?.ownedNfts;
    console.log({ myNfts });
    // const ownedIds = data?.ownedNfts.map((x) => x["tokenId"]);
    const return_value = myNfts.filter((val) => tokenIds.includes(val.tokenId));
    console.log({ return_value });
    return myNfts;
  }
  async function getNfts() {
    setLoading(true);
    // console.log("get tokens");

    // mainnet
    //web3 = new Web3(Web3.givenProvider);

    // goerli
    // const web3 = new Web3(
    //   "https://goerli.infura.io/v3/fc3edf89dddc47beaefbe5b3becadf5d"
    // );

    /*check if connected
		var listening = await web3.eth.net.isListening().then(console.log);
		if ( ! listening ) {
			alert( "Error connecting to metamask!" );
		};*/

    // load accounts
    //await window.ethereum.enable();
    // const accounts = await window.ethereum.request({
    //   method: "eth_requestAccounts",
    // });
    // const account = accounts[0];
    // console.log({ account });

    // if loading the accounts failed, try a different method
    // if (account === undefined) {
    //   account = await window.ethereum.selectedAddress;
    //   console.log("[ getNfts ] account (ethereum):", account);
    // }
    const mappedIds = await getTokens(account);

    setNfts(mappedIds);
    console.log({ mappedIds });
    setLoading(false);
  }
  async function getDosNfts() {
    setLoading(true);
    // console.log("get tokens");
    // mainnet
    //web3 = new Web3(Web3.givenProvider);
    // goerli
    // const web3 = new Web3(
    //   "https://goerli.infura.io/v3/fc3edf89dddc47beaefbe5b3becadf5d"
    // );
    /*check if connected
		var listening = await web3.eth.net.isListening().then(console.log);
		if ( ! listening ) {
			alert( "Error connecting to metamask!" );
		};*/
    // load accounts
    //await window.ethereum.enable();
    // const accounts = await window.ethereum.request({
    //   method: "eth_requestAccounts",
    // });
    // const account = accounts[0];
    // console.log({ account });

    // if loading the accounts failed, try a different method
    // if (account === undefined) {
    //   account = await window.ethereum.selectedAddress;
    //   console.log("[ getNfts ] account (ethereum):", account);
    // }
    const mappedIds = await getDosTokens(account);

    setDosNfts(mappedIds);
    console.log({ mappedIds });
    setLoading(false);
  }
  useEffect(() => {
    if (account) {
      getNfts();
      getDosNfts();
    }
  }, [account]);

  const handleSelect = (val) => {
    setSelectedNft((prevSelectedNft) => [...prevSelectedNft, val]);
  };

  const handleUnselect = (val) => {
    setSelectedNft((prevSelectedNft) =>
      prevSelectedNft.filter((item) => item !== val)
    );
  };
  return (
    <>
      <Navbar setTheme={setTheme} theme={theme} />
      <div
        style={{
          backgroundColor: theme ? "white" : "#111",
          overflow: "hidden",
        }}
      >
        <div className={theme ? styles.outer : dark.outer}>
          <div className={theme ? styles.migration : dark.migration}>
            <div className={styles.migdiv}>
              <h1 style={{ color: theme ? "#fff" : "#f0f0f0" }}>
                Dospunks Migration
              </h1>
              <p className={theme ? styles.migration_p : dark.migration_p}>
                Connect your account to free your DOS Punks from the OpenSea Shared contract to a fresh ERC721 with new benefits!
              </p>
              <div className={styles.only_images}>
                <div>
                  <img style={{width:"315px", height:"315px"}} src="https://gpmqvddbd6fkqvzmt4lyjpjlynxdkjc7vvohfpuolfly7i7xtkcq.arweave.net/M9kKjGEfiqhXLJ8XhL0rw241JF-tXHK-jllXj6P3moU/0275.png" alt="" />
                  <p className={styles.img1p}>OPENSEA ERC1155 </p>
                </div>
                <div>
                  <img style={{width:"315px", height:"315px"}} src="https://gpmqvddbd6fkqvzmt4lyjpjlynxdkjc7vvohfpuolfly7i7xtkcq.arweave.net/M9kKjGEfiqhXLJ8XhL0rw241JF-tXHK-jllXj6P3moU/0275.png" alt="" />
                  <p className={styles.img2p}>DOS ERC721 </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.main}>
          <div className={styles.mig_punks}>
            <h1 style={{ color: theme ? "#111" : "#f0f0f0" }}>
              Migrate Your Punks
            </h1>
            <img
              style={{
                background: "#f2f3f6",
                borderRadius: "9999px",
                padding: "0.5rem",
                cursor: "pointer",
              }}
              src="../images/Vector.png"
              alt=""
            />
          </div>
          <p style={{ marginBottom: "2rem", color: theme ? "#555" : "#999" }}>
            Connect your account to migrate your Dospunks
          </p>
          <Row className={styles.btndiv1}>
            <Row className={styles.btndiv1}>
              <Button
                disabled={!active || selectedNft.length < 1}
                className={theme ? styles.migbtn : dark.migbtn}
                onClick={() => setOpenSelected(true)}
              >
                MIGRATE SELECTED
              </Button>
              <Button
                onClick={() => setOpenAll(true)}
                disabled={!active || nfts.length < 1}
                className={theme ? styles.migall : dark.migall}
              >
                MIGRATE ALL
              </Button>
            </Row>
            {active ? (
              <Button
                className={theme ? styles.disbtn : dark.disbtn}
                onClick={() => {
                  deactivate();
                  localStorage.removeItem("provider");
                  setNfts([]);
                }}
              >
                Disconnect
              </Button>
            ) : (
              <ConnectWallet />
            )}
          </Row>
          <div className={styles.btndiv2}></div>
        </div>
        <div className={styles.only_images2}>
          {account ? (
            loading ? (
              <Row className={styles.loadingRow}>
                <Loader />
              </Row>
            ) : nfts.length > 0 ? (
              <Row gutter={[{ xs: 8, sm: 8, md: 16 }, 32]}>
                {nfts?.map((value, index) => (
                  <Col key={index} xs={12} md={12} lg={6}>
                    <NftCard
                      show={true}
                      val={value}
                      theme={theme}
                      key={value.id}
                      onSelect={handleSelect}
                      onUnselect={handleUnselect}
                      isSelected={selectedNft.includes(value)}
                    />
                  </Col>
                ))}
              </Row>
            ) : (
              <Row style={{ alignItems: "center", justifyContent: "center" }}>
                <h1 style={{ color: theme ? "#111" : "#f0f0f0" }}>
                  No DOS PUNKS FOUND!
                </h1>
              </Row>
            )
          ) : (
            <Row style={{ alignItems: "center", justifyContent: "center" }}>
              <h1 style={{ color: theme ? "#111" : "#f0f0f0" }}>
                Connect Wallet to Migrate!
              </h1>
            </Row>
          )}
        </div>
        <div className={styles.only_images2}>
          <h1 style={{ color: theme ? "#111" : "#f0f0f0", padding: "2rem 0" }}>
            Redeemed
          </h1>
          {account ? (
            loading ? (
              <Row className={styles.loadingRow}>
                <Loader />
              </Row>
            ) : dosNfts.length > 0 ? (
              <Row gutter={[{ xs: 8, sm: 8, md: 16 }, 32]}>
                {dosNfts?.map((value, index) => (
                  <Col key={index} xs={12} md={12} lg={6}>
                    <NftCard
                      show={true}
                      erc721={true}
                      theme={theme}
                      val={value}
                      key={value.id}
                      onSelect={handleSelect}
                      onUnselect={handleUnselect}
                      isSelected={selectedNft.includes(value)}
                    />
                  </Col>
                ))}
              </Row>
            ) : (
              <Row style={{ alignItems: "center", justifyContent: "center" }}>
                <h1 style={{ color: theme ? "#111" : "#f0f0f0" }}>
                  No DOS PUNKS FOUND!
                </h1>
              </Row>
            )
          ) : (
            <Row style={{ alignItems: "center", justifyContent: "center" }}>
              <h1 style={{ color: theme ? "#111" : "#f0f0f0" }}>
                Connect Wallet to See!
              </h1>
            </Row>
          )}
        </div>

        <div className={theme ? styles.migben : dark.migben}>
          <div className={styles.bendiv}>
            <h1>MIGRATION BENEFITS</h1>
            <p className={styles.benp}>
              We are no longer tied to OpenSea and can be listed on other NFT
              platforms like Foundation, Coinbase, Rarible and ArtifactX – we have true
              freedom flexibility <br />
              <br />
              Custom ERC721 allows us to pull statistics and ownership without
              having to comb through the monolithic OS shared contract. It's a
              standard specific to the art community and blue-chip NFT projects{" "}
              <br />
              <br /> Allows DOS Punks to participate in a wider array of dApps
              (decentralized apps), functions (for unique utility) <br />
              <br />
              Images stored immutably on ARweave <br />
              <br />
              Enhanced metadata <br />
              <br />
              Stake for $DOS
            </p>
          </div>
        </div>

        <footer className={styles.footer}>
          <Row className={styles.mainRow}>
            <Row className={styles.innerRow}>
              <Col xs={24} sm={24} md={17}>
                {/* <Image src={logo} width={48} height={48} className={styles.logo} /> */}

                <span>Privacy Policy</span>
                <span className="ddd">Terms of Service</span>
                <span className={styles.copyRight}>
                  ©Dospunks 2023, All Rights Reserved.
                </span>
              </Col>
              <Col xs={24} sm={16} md={4}>
                <h6>Genesis Collections</h6>
                <p>DOSPUNKS</p>
                <p>DOSPUNKS (TEZ)</p>
                <p>DOS TRASHBIRDS</p>
                <p>DOSAMIGOS</p>
              </Col>
              <Col xs={24} sm={8} md={3}>
                <h6>Connect</h6>

                <p>Twitter</p>

                <p>TELGRAM</p>
               
                <p>Opensea</p>
              </Col>
            </Row>
          </Row>
        </footer>
        {/* Modals */}
        <ConfirmMigrate
          open={openSelected}
          setOpen={setOpenSelected}
          selectedNft={selectedNft}
        />
        <ConfrimMigrateAll
          open={openAll}
          setOpen={setOpenAll}
          selectedNft={nfts}
        />
      </div>
    </>
  );
};

export default Migration;
